import { render, staticRenderFns } from "./Currentbasisc.vue?vue&type=template&id=e362e2b6&scoped=true&"
import script from "./Currentbasisc.vue?vue&type=script&lang=js&"
export * from "./Currentbasisc.vue?vue&type=script&lang=js&"
import style0 from "./Currentbasisc.vue?vue&type=style&index=0&id=e362e2b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e362e2b6",
  null
  
)

export default component.exports